import React, { Component } from 'react';
import autosize from 'autosize';

/*export default class Textarea extends Component {

  componentDidMount () {
    if (this.multilineTextarea) {
      this.multilineTextarea.style.height = 'auto';
    }
  }

  changeTextarea = () => {
    this.multilineTextarea.style.height = 'auto';
    this.multilineTextarea.style.height = this.multilineTextarea.scrollHeight + 'px';
  };

  render () {
    return (
        <textarea
            onChange={this.changeTextarea}
            ref={ref => this.multilineTextarea = ref}
        />
    );
  }
}*/

export default class Textarea extends Component {
  componentDidMount(){
    this.textarea.focus();
    autosize(this.textarea);
  }

  render(){
    const style = {
      maxHeight:'375px',
      minHeight:'38px',
      minWidth: '280px',
      resize:'none',
      padding:'9px',
      boxSizing:'border-box',
      fontSize:'15px',
      backgroundColor: '#F0F8FF'};
    return (
          <textarea
              disabled={this.props.disabled}
              style={style}
              ref={c=>this.textarea=c}
              placeholder={this.props.placeholder}
              rows={2}
              value={this.props.value}
              onChange={this.props.onChange}
          />
    );
  }

}
